import { render, staticRenderFns } from "./Meeting.Left.Record.vue?vue&type=template&id=2b1b2776&scoped=true&"
import script from "./Meeting.Left.Record.vue?vue&type=script&lang=js&"
export * from "./Meeting.Left.Record.vue?vue&type=script&lang=js&"
import style0 from "./Meeting.Left.Record.vue?vue&type=style&index=0&id=2b1b2776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b2776",
  null
  
)

export default component.exports